import rules_list from './rules'

const default_redirect = { name: 'home' }

/**
 * Проверка прав доступа к роутам
 * 
 * @param {array} rules - список проверямых правил
 * @param {object} redirect - имя роута для редиректа
 */
export default function(rules, redirect) {
    return function(to, from, next) {
        let rules_verifying = []
        
        for (let n = 0, len = rules.length; n < len; n++) {
            const rule_trim = rules[n].trim()

            const is_negative = rule_trim[0] == '!'
            const rule = is_negative ? rule_trim.slice(1) : rule_trim
    
            if (rule in rules_list) {
                const verifying = rules_list[rule](to, from, next)

                if (verifying instanceof Promise) {
                    if (is_negative) {
                        const reverse_verifying = new Promise((resolve, reject) => {
                            verifying.then(payload => reject(payload)).catch(payload => resolve(payload))
                        })
                        rules_verifying.push(reverse_verifying)
                    } else {
                        rules_verifying.push(verifying)
                    }
                } else {
                    if (is_negative ? verifying.allow : !verifying.allow) {
                        return next({
                            replace: true,
                            ...(redirect || verifying.redirect || default_redirect),
                            params: { $referrer: to },
                        })
                    } else {
                        rules_verifying.push(Promise.resolve(verifying))
                    }
                }
            }
        }

        Promise.allSettled(rules_verifying).then(rslts => {
            for (let i = 0; i < rslts.length; i++) {
                if (rslts[i].status == 'rejected') {
                    next({
                        replace: true,
                        ...(redirect || rslts[i].reason.redirect || default_redirect),
                        params: { $referrer: to },
                    })

                    return
                }
            }

            next()
        })

        /* Promise.all(rules_verifying).then(verifying => {
            next()
        }).catch(verifying => {
            next({
                replace: true,
                ...(redirect || verifying.redirect || default_redirect),
                params: { $referrer: to },
            })
        }) */
    }
}